import { SxProps } from '@mui/material';
import { red2, white } from 'app/components/ThemeProvider/colors';

export const paperProps: SxProps = { borderRadius: '8px', width: '464px', maxHeight: 'none'};

export const title: SxProps = {
    fontSize: '24px',
    fontWeight: '600',
};

export const dialogTitle: SxProps = {
    display: 'flex',
    justifyContent: 'space-between',
    p: '36px 36px 0px 36px',
};

export const closeBtn: SxProps = {
    padding: '10px',
    minWidth: '36px',
    height: '36px',
    width: '36px',
    borderRadius: '8px',
    alignItems: 'centre',

    '& .MuiSvgIcon-root': {
        width: '16px',
        height: '16px',
    },
};

export const dialogActions: SxProps = {
    p: '0 36px 36px 36px',
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-start',
    mt: '30px'
};

export const mainText = {
    fontSize: '18px',
    fontWeight: 600,
};
export const secondaryText = {
    fontSize: '14px',
    fontWeight: 400,
    color: '#14191F8F',
};
export const deleteBtn: SxProps = {
    background: red2,
    color: white,

    '&:hover': {
        background: red2,
    },
};
